'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var PropTypes = require('prop-types');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var timeoutsShape = process.env.NODE_ENV !== 'production' ? PropTypes__default["default"].oneOfType([PropTypes__default["default"].number, PropTypes__default["default"].shape({
  enter: PropTypes__default["default"].number,
  exit: PropTypes__default["default"].number,
  appear: PropTypes__default["default"].number
}).isRequired]) : null;
var classNamesShape = process.env.NODE_ENV !== 'production' ? PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].shape({
  enter: PropTypes__default["default"].string,
  exit: PropTypes__default["default"].string,
  active: PropTypes__default["default"].string
}), PropTypes__default["default"].shape({
  enter: PropTypes__default["default"].string,
  enterDone: PropTypes__default["default"].string,
  enterActive: PropTypes__default["default"].string,
  exit: PropTypes__default["default"].string,
  exitDone: PropTypes__default["default"].string,
  exitActive: PropTypes__default["default"].string
})]) : null;

exports.classNamesShape = classNamesShape;
exports.timeoutsShape = timeoutsShape;
